<template>
    <div
        class="loader"
        :class="{loader_hover: hover}"
    >
        <img
            src="/uikit/svg/icons/loader.svg"
            :style="{width: pxSize, height: pxSize}"
        />
    </div>
</template>

<script>
export default {
    name: "Loader",
    props: {
        size: {
            type: String,
            default: 'md'
        },
        hover: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pxSize () {
            if (this.size === 'lg') {
                return '120px';
            } else if (this.size === 'sm') {
                return '30px';
            }
            return '60px';
        }
    }
}
</script>

<style lang="scss">
    .loader {
        text-align: center;
        user-select: none;
        height: 100%;

        &_hover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.3);

            img {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

    .center-vertical {
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        margin:auto;
        height: 10%;
    }
</style>